const OurLivesMoments = [
  {
    src: 'https://live.staticflickr.com/65535/47981726873_edf3b7ef33_o.jpg',
    thumbnail: 'https://live.staticflickr.com/65535/47981726873_edf3b7ef33_o.jpg',
    thumbnailWidth: 1932,
    thumbnailHeight: 2576,
    // tags: [{ value: 'Warriors', title: 'Warriors' }, { value: 'Playoffs', title: 'Playoffs' }],
    caption: 'Disney World - Orlando, FL',
  },
  {
    src: 'https://live.staticflickr.com/65535/47981727073_34931f3f39_o.jpg', thumbnail: 'https://live.staticflickr.com/65535/47981727073_34931f3f39_o.jpg', thumbnailWidth: 1200, thumbnailHeight: 1600, caption: 'Universal Studios - Orlando, FL',
  },
  {
    src: 'https://live.staticflickr.com/65535/47981729387_c50b0f7c9d_o.jpg', thumbnail: 'https://live.staticflickr.com/65535/47981729387_c50b0f7c9d_o.jpg', thumbnailWidth: 1932, thumbnailHeight: 2576, caption: 'Warriors Playoff Game - Oracle Arena',
  },
  {
    src: 'https://live.staticflickr.com/65535/47981779466_8dbc9eeaaa_o.jpg', thumbnail: 'https://live.staticflickr.com/65535/47981779466_8dbc9eeaaa_o.jpg', thumbnailWidth: 1932, thumbnailHeight: 2576, caption: 'Pace Gallery - Palo Alto, CA',
  },
  {
    src: 'https://live.staticflickr.com/65535/47981779431_d0a5d84832_o.jpg', thumbnail: 'https://live.staticflickr.com/65535/47981779431_d0a5d84832_o.jpg', thumbnailWidth: 1932, thumbnailHeight: 2576, caption: 'Giants Game - AT&T Park',
  },
  {
    src: 'https://live.staticflickr.com/65535/47981726693_36672d8199_o.jpg', thumbnail: 'https://live.staticflickr.com/65535/47981726693_36672d8199_o.jpg', thumbnailWidth: 3024, thumbnailHeight: 4032, caption: 'Wine Tasting - Napa Valley, CA',
  },
  {
    src: 'https://live.staticflickr.com/65535/47981729192_fd9db2d12e_o.jpg', thumbnail: 'https://live.staticflickr.com/65535/47981729192_fd9db2d12e_o.jpg', thumbnailWidth: 3024, thumbnailHeight: 4032, caption: 'Disneyland - Anaheim, CA',
  },
  {
    src: 'https://live.staticflickr.com/65535/47981729177_31cf1ebf81_o.jpg', thumbnail: 'https://live.staticflickr.com/65535/47981729177_31cf1ebf81_o.jpg', thumbnailWidth: 3024, thumbnailHeight: 4032, caption: 'Ruins of St. Paul - Macau',
  },
  {
    src: 'https://live.staticflickr.com/65535/47981729587_313c58f5c2_o.jpg', thumbnail: 'https://live.staticflickr.com/65535/47981729587_313c58f5c2_o.jpg', thumbnailWidth: 4032, thumbnailHeight: 3024, caption: 'Victoria Peak - Hong Kong',
  },
  {
    src: 'https://live.staticflickr.com/65535/47981726363_ce4b0b8de5_o.jpg', thumbnail: 'https://live.staticflickr.com/65535/47981726363_ce4b0b8de5_o.jpg', thumbnailWidth: 3024, thumbnailHeight: 4032, caption: 'Disneyland - Shanghai, China',
  },
  {
    src: 'https://live.staticflickr.com/65535/47981729492_9b7812b4f3_o.jpg', thumbnail: 'https://live.staticflickr.com/65535/47981729492_9b7812b4f3_o.jpg', thumbnailWidth: 4032, thumbnailHeight: 3024, caption: 'Lake Louise - Alberta, Canada',
  },
  {
    src: 'https://live.staticflickr.com/65535/47981779141_b5f5f89323_o.jpg', thumbnail: 'https://live.staticflickr.com/65535/47981779141_b5f5f89323_o.jpg', thumbnailWidth: 1932, thumbnailHeight: 2576, caption: 'Disneyland - Tokyo, Japan',
  },
  {
    src: 'https://live.staticflickr.com/65535/47981726303_ae730010fa_o.jpg', thumbnail: 'https://live.staticflickr.com/65535/47981726303_ae730010fa_o.jpg', thumbnailWidth: 1932, thumbnailHeight: 2576, caption: 'Fushimi Inari Taisha - Kyoto, Japan',
  },
  {
    src: 'https://live.staticflickr.com/65535/47981779056_1d6ba84b95_o.jpg', thumbnail: 'https://live.staticflickr.com/65535/47981779056_1d6ba84b95_o.jpg', thumbnailWidth: 3024, thumbnailHeight: 4032, caption: 'Hakone, Japan',
  },
  {
    src: 'https://live.staticflickr.com/65535/47981728887_d0afa52286_o.jpg', thumbnail: 'https://live.staticflickr.com/65535/47981728887_d0afa52286_o.jpg', thumbnailWidth: 3024, thumbnailHeight: 4032, caption: 'Effiel Tower - Paris, France',
  },
  {
    src: 'https://live.staticflickr.com/65535/47981726118_fae393f0ce_o.jpg', thumbnail: 'https://live.staticflickr.com/65535/47981726118_fae393f0ce_o.jpg', thumbnailWidth: 3024, thumbnailHeight: 4032, caption: 'Grand Harbor - Burlingame CA',
  },
  {
    src: 'https://live.staticflickr.com/65535/47981729462_99b1592065_o.jpg', thumbnail: 'https://live.staticflickr.com/65535/47981729462_99b1592065_o.jpg', thumbnailWidth: 1931, thumbnailHeight: 2415, caption: 'Warriors SWAG - Sunnyvale, CA',
  },
  {
    src: 'https://live.staticflickr.com/65535/47981726063_f9d1715e45_o.jpg', thumbnail: 'https://live.staticflickr.com/65535/47981726063_f9d1715e45_o.jpg', thumbnailWidth: 4032, thumbnailHeight: 3024, caption: 'Notre Dame - Paris, France',
  },
  {
    src: 'https://live.staticflickr.com/65535/47981728697_e150e973d6_o.jpg', thumbnail: 'https://live.staticflickr.com/65535/47981728697_e150e973d6_o.jpg', thumbnailWidth: 1932, thumbnailHeight: 2576, caption: 'Pike Place Market - Seattle, WA',
  },
  {
    src: 'https://live.staticflickr.com/65535/47981728672_2ae6752b37_o.jpg', thumbnail: 'https://live.staticflickr.com/65535/47981728672_2ae6752b37_o.jpg', thumbnailWidth: 1932, thumbnailHeight: 2576, caption: '2018 Narvar Holiday Party (Part 1)',
  },
  {
    src: 'https://live.staticflickr.com/31337/47981778731_3dfb0af593_o.jpg', thumbnail: 'https://live.staticflickr.com/31337/47981778731_3dfb0af593_o.jpg', thumbnailWidth: 576, thumbnailHeight: 720, caption: '2018 Narvar Holiday Party (Part 2)',
  },
  {
    src: 'https://live.staticflickr.com/65535/47981778696_3ce55c1ef9_o.jpg', thumbnail: 'https://live.staticflickr.com/65535/47981778696_3ce55c1ef9_o.jpg', thumbnailWidth: 3024, thumbnailHeight: 4032, caption: 'Trevi Fountain - Rome, Italy',
  },
];

// const OurLivesMoments = [];
const EngagementMoments = [
  {
    src: 'https://live.staticflickr.com/65535/47981938351_affe24ec83_o.jpg', thumbnail: 'https://live.staticflickr.com/65535/47981938351_affe24ec83_o.jpg', thumbnailWidth: 1080, thumbnailHeight: 1080, caption: 'Robert E Wooley State Park (Part 1)',
  },
  {
    src: 'https://live.staticflickr.com/65535/47981891542_f979cc8c33_o.jpg', thumbnail: 'https://live.staticflickr.com/65535/47981891542_f979cc8c33_o.jpg', thumbnailWidth: 1080, thumbnailHeight: 1080, caption: 'Robert E Wooley State Park (Part 2)',
  },
  {
    src: 'https://live.staticflickr.com/65535/47981887518_9fccbc1a55_o.jpg', thumbnail: 'https://live.staticflickr.com/65535/47981887518_9fccbc1a55_o.jpg', thumbnailWidth: 3446, thumbnailHeight: 4643, caption: 'City Hall San Francisco (Part 1)',
  },
  {
    src: 'https://live.staticflickr.com/65535/47981891522_90688921bc_o.jpg', thumbnail: 'https://live.staticflickr.com/65535/47981891522_90688921bc_o.jpg', thumbnailWidth: 1600, thumbnailHeight: 900, caption: 'City Hall San Francisco (Part 2)',
  },
  {
    src: 'https://live.staticflickr.com/65535/47981891527_9f87676889_o.jpg', thumbnail: 'https://live.staticflickr.com/65535/47981891527_9f87676889_o.jpg', thumbnailWidth: 1932, thumbnailHeight: 2576, caption: 'City Hall San Francisco (Part 3)',
  },
];


export { OurLivesMoments, EngagementMoments };
